import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

import { AccessControlState } from '../slice/initialStateGoalAccessMatrix';

export const getAllTemplatesV1Api = () => {
  const url = endpoints.admin.goalConfigV1.templates;

  // @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getTemplateByIdV1Api = (templateId: string) => {
  const url = endpoints.admin.goalConfigV1.templateById(templateId);

  // @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const createTemplateV1Api = (templateData: AccessControlState) => {
  const url = endpoints.admin.goalConfigV1.createTemplate;

  // @ts-ignore
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: templateData,
  });
};

export const updateTemplateV1Api = (templateId: number, templateData: AccessControlState) => {
  const url = endpoints.admin.goalConfigV1.templateById(templateId);

  // @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: templateData,
  });
};

export const validateAccessControlTableApi = (tableData: {
  rolesToCreateConfig?: AccessControlState['accessControl']['rolesToCreateConfig'];
  rolesToViewUpdateStatusEditDeleteConfig?: AccessControlState['accessControl']['rolesToViewUpdateStatusEditDeleteConfig'];
  rolesToUploadInsightsCustomTagConfig?: AccessControlState['accessControl']['rolesToUploadInsightsCustomTagConfig'];
}) => {
  const url = endpoints.admin.goalConfigV1.validateAccessControlTable;

  // @ts-ignore
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: tableData,
  });
};
